// ai-report.js
// Location: assets/ai-report.js
// Purpose: Animations for the Japan AI Report 2025-2026 page
// Why: IntersectionObserver-based scroll reveals, count-up, bar/gap animations, GSAP parallax
// RELEVANT FILES: sections/ai-report.liquid, assets/ai-report.css, templates/page.ai-report.json

/* ================================================================
   AI Report — Animations (IntersectionObserver + counting + GSAP)
   ================================================================ */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const root = document.querySelector('.ai-report-page');
  if (!root) return;

  /* ---- Intersection Observer for scroll reveals ---- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  root.querySelectorAll('[data-anim]').forEach(el => io.observe(el));

  /* ---- Number count-up ---- */
  function countUp(el, target) {
    const duration = 1200;
    const start = performance.now();
    const isDecimal = String(target).includes('.');

    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const val = target * eased;

      if (isDecimal) {
        el.textContent = val.toFixed(1);
      } else if (target >= 1000) {
        el.textContent = Math.round(val).toLocaleString();
      } else {
        el.textContent = Math.round(val);
      }

      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const countObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const target = parseFloat(e.target.dataset.count);
        countUp(e.target, target);
        countObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });

  root.querySelectorAll('[data-count]').forEach(el => countObserver.observe(el));

  /* ---- Bar animations ---- */
  const barObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.querySelectorAll('.bar-fill').forEach((bar, i) => {
          setTimeout(() => {
            bar.style.width = bar.dataset.width + '%';
          }, i * 150);
        });
        barObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });

  root.querySelectorAll('[data-anim="bars"]').forEach(el => barObserver.observe(el));

  /* ---- Gap bar grow ---- */
  const gapObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.querySelectorAll('.gap-bar').forEach((bar, i) => {
          setTimeout(() => bar.setAttribute('data-grown', ''), i * 200);
        });
        gapObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });

  root.querySelectorAll('.gap-visual').forEach(el => gapObserver.observe(el));

  /* ---- Timeline line grow ---- */
  const tlObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const line = e.target.querySelector('.tl-line');
        if (line) line.classList.add('grown');
        tlObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  root.querySelectorAll('.timeline').forEach(el => tlObserver.observe(el));

  /* ---- GSAP ScrollTrigger (if loaded) ---- */
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(root.querySelector('.closing-year'), {
      y: -40,
      scrollTrigger: {
        trigger: root.querySelector('.closing'),
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      }
    });

    root.querySelectorAll('.sect-label').forEach(label => {
      gsap.from(label, {
        x: -20,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: label,
          start: 'top 85%',
          once: true,
        }
      });
    });
  }
});
